import React from 'react';
import PropTypes from 'prop-types';
import { MathJax } from 'better-react-mathjax';
import style from './style.module.scss';

/**
 * Content:
 *   - Content for all Tooltip Components
 */
export function Content(props) {
  const className = `${style.content} ${props.className}`;
  return (
    <div className={className}>
      <p>
        <MathJax>
          {props.text}
        </MathJax>
      </p>
    </div>
  );
}

Content.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * content text
   */
   text: PropTypes.string,
};

Content.defaultProps = {
  text: '',
  className: '',
};
